﻿import "script-loader!../../../../wwwroot/lib/jquery/dist/jquery.min.js";
import "script-loader!../../../../wwwroot/lib/Popper/popper.min.js";
import "script-loader!../../../../wwwroot/lib/bootstrap/dist/js/bootstrap.min.js";
import "script-loader!../../../../wwwroot/lib/metisMenu/dist/jquery.metisMenu.js";
import "script-loader!../../../../wwwroot/lib/pace/pace.min.js";
import "script-loader!../../../../wwwroot/lib/slimScroll/jquery.slimscroll.min.js";
import "script-loader!../../../../wwwroot/lib/wow/wow.min.js";
import "script-loader!../../../../wwwroot/js/site.js";
import "script-loader!../../../../wwwroot/js/script.js";
import "script-loader!../../../../wwwroot/lib/toastr/toastr.min.js";
window.dispatchEvent(new Event('outsideBundleLoaded'));